import { render, staticRenderFns } from "./AModalClaveChange.vue?vue&type=template&id=46125c59"
import script from "./AModalClaveChange.vue?vue&type=script&lang=js"
export * from "./AModalClaveChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports